<template lang="">
  <section
    v-if="design == 'default'"
    class="mt-1 mt-lg-3 px-lg-2 bg-body-tertiary text-primary p-lg-4 d-lg-flex justify-content-center text-center align-items-center mx-2 mx-lg-0 py-3"
    :class="{
      'd-block d-lg-none': showSectionSmall && hideSectionSmall,
      'd-none d-lg-block': !showSectionSmall && hideSectionSmall,
    }"
  >
    <span class="text-uppercase text-secondary" :class="fontSize">
      {{ getTitle("home", "your_purchase_is") }}
    </span>
    <span class="fw-bold text-uppercase ms-1 text-secondary" :class="fontSize">
      {{ getTitle("home", "protected_by") }}
    </span>
    <img
      src="/images/3DSecure.png"
      width="85"
      height="35"
      alt="3D Secure"
      class="mx-2 mx-lg-3"
      :style="{ height: secureHeight, width: 'auto' }"
    />
    <span class="text-uppercase text-secondary" :class="fontSize">
      {{ getTitle("home", "through") }}
    </span>
    <img
      src="/images/masterCardIdCheck.png"
      width="85"
      height="35"
      alt="Master Card"
      class="mx-2 mx-lg-3"
      :style="{ height: masterHeight, width: 'auto' }"
    />
    <img
      src="/images/verifiedByVisa.png"
      width="85"
      height="35"
      alt="Visa"
      class="mx-2 mx-lg-3"
      :style="{ height: visaHeight, width: 'auto' }"
    />
  </section>
  <section
    v-if="design == 'small'"
    class="px-lg-2 bg-body-tertiary text-primary d-flex flex-column justify-content-center align-items-center"
    :class="{
      'd-block d-lg-none': showSectionSmall && hideSectionSmall,
      'd-none d-lg-block': !showSectionSmall && hideSectionSmall,
    }"
  >
    <div class="d-flex justify-content-center align-items-center p-1">
      <span class="text-uppercase text-secondary" :class="fontSize">
        {{ getTitle("home", "your_purchase_is") }}
      </span>
      <span
        class="fw-bold text-uppercase ms-1 text-secondary"
        :class="fontSize"
      >
        {{ getTitle("home", "protected_by") }}
      </span>
      <img
        src="/images/3DSecure.png"
        width="85"
        height="35"
        alt="3D Secure"
        class="mx-2 mx-lg-3"
        :style="{ height: secureHeight, width: 'auto' }"
      />
    </div>
    <div class="d-flex justify-content-center align-items-center p-1">
      <span class="text-uppercase text-secondary" :class="fontSize">
        {{ getTitle("home", "through") }}
      </span>
      <img
        src="/images/masterCardIdCheck.png"
        width="85"
        height="35"
        alt="Master Card"
        class="mx-2 mx-lg-3"
        :style="{ height: masterHeight, width: 'auto' }"
      />
      <img
        src="/images/verifiedByVisa.png"
        width="85"
        height="35"
        alt="Visa"
        class="mx-2 mx-lg-3"
        :style="{ height: visaHeight, width: 'auto' }"
      />
    </div>
  </section>
</template>
<script lang="ts">
import { getTitleTranslate } from "@/utils/general";
export default {
  props: {
    fontSize: {
      type: String,
      default: "fs-3",
    },
    secureHeight: {
      type: String,
      default: "50px",
    },
    masterHeight: {
      type: String,
      default: "24px",
    },
    visaHeight: {
      type: String,
      default: "24px",
    },
    showSectionSmall: {
      type: Boolean,
      default: false,
    },
    hideSectionSmall: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: String,
      default: "rounded-0",
    },
    onlyImage: {
      type: Boolean,
      default: false,
    },
    design: {
      type: String,
      default: "default",
    },
  },
  methods: {
    getTitle(section: string, name: string) {
      return getTitleTranslate(section, name);
    },
  },
};
</script>
<style lang=""></style>
